import constants from 'constants/index'

const typeControllerIsPresent = (agents) => {
  const isPresent = agents?.map((agent) => {
    if (agent?.agentType === constants.dataTreatmentAgent.CONTROLLER_TYPE) {
      return true
    }

    return false
  })

  return isPresent.includes(true)
}

export default typeControllerIsPresent
